import "jquery-global";
import "jquery-ui";
import "jquery.cookie";
import "jquery.tipsy";
import "jquery.form";
import "jquery.validate";
import "jquery.timers";
import "jquery.datetimepicker.full";
import "jquery.powertip.min";
import "jquery.ajax.helpers";
import "jquery.scrollTo-min";
import "jquery.numeric.min";
import "jquery.fancybox.min";
import "jquery.fancybox.pack";
import "jquery.mousewheel-3.1.12.pack";
import "switchery";

import "digits.sdk";
import "chart.umd.min";
import "bootstrap/popper";
import "bootstrap/bootstrap.min";

import "new/jquery.dataTables.min";
import { initWorkspaceScripts, registerWorkspaceValidators } from "lib/helpers";
import "new/dataTables.bootstrap.min";
import "new/moment.min";
import "new/jquery.dataTables.yadcf";
import "new/highcharts";

registerWorkspaceValidators();
$(document).ready(initWorkspaceScripts);
